import React from 'react';
import { ListItemText, Tooltip } from '@material-ui/core';
import { contact } from '../../../../model/contact';

export const ContactInfo = (props: { contact: contact, classes: any }) => {
    const { contact } = props;

    let text = '';
    if (contact.surname && contact.name)
        text = `${contact.surname} ${contact.name}`;
    else
        text = `${contact.email}`;


    return <Tooltip title=''>
        <ListItemText primary={text} primaryTypographyProps={{ noWrap: true, variant: 'body1', style: { display: 'block' } }} />
    </Tooltip>
}